import styled from "styled-components";

import { theme } from "@tm/utility/global";
import { deviceType } from "../../../../utils";

export const FormPage = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 16px 48px;
  box-sizing: border-box;
  background: ${theme.disabledGrey2};
  overflow-x: hidden;

  @media ${deviceType.mobile} {
    padding: 16px 16px 140px;
    display: block;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  width: 100%;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const Column = styled.div<{ $mobileOrder?: number }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    order: ${(p) => p.$mobileOrder ?? 0};
    gap: 12px;
  }
`;

export const LeftColumn = styled(Column).attrs({ $mobileOrder: 2 })``;
export const RightColumn = styled(Column).attrs({ $mobileOrder: 1 })``;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 240px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-height: 240px;
  justify-content: center;
`;

export const ErrorText = styled.p`
  font-size: 14px;
  color: ${theme.greyText};
  margin: 0;
`;

export const RetryButton = styled.button`
  border: none;
  background: ${theme.blueText};
  color: ${theme.whiteText};
  font-weight: 700;
  padding: 10px 24px;
  border-radius: 8px;
  cursor: pointer;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: ${theme.blueText};
  font-weight: 700;
  cursor: pointer;
  padding: 8px 0;
`;

export const BackIconWrapper = styled.span`
  display: inline-flex;
  transform: rotate(-90deg);
`;
